export const ClientLocale = {
    cs: "cs",
    en: "en",
} as const;

export type ClientLocale = (typeof ClientLocale)[keyof typeof ClientLocale];

import {
    Address,
    Campaign,
    CampaignApplicationResolution,
    CampaignApplicationState,
    File,
    Gender,
    QuestionnaireResponse,
} from "src/graphql/generated/graphql";

interface CampaignApplicationReviewer {
    id: string;
    profile: ReviewerProfile;
    profileImage: File;
    socials: ReviewerSocials;
    isBlacklisted: boolean;
    blacklistedUntil: number;
    totalApplicationsCount: number;
    selectedApplicationsCount: number;
    alternateApplicationsCount: number;
    rejectedApplicationsCount: number;
    clientCounts?: ReviewerClientCounts;
}

interface ReviewerProfile {
    firstName: string;
    lastName: string;
    fullName?: string;
    gender: Gender;
    birthDate: number;
    age?: number;
    phoneNumber: string;
    address: Address;
}

interface ReviewerSocials {
    hasFb: boolean;
    fbFollowers: number;

    hasIg: boolean;
    igFollowers: number;
}

interface ReviewerClientCounts {
    any: number;
    selected: number;
    alternate: number;
    rejected: number;
}

export interface CampaignApplicationRestApi {
    id: string;
    campaign: Campaign;
    reviewer: CampaignApplicationReviewer;
    state: CampaignApplicationState;
    appliedAt: number;
    isUnselected: boolean;
    questionnaireResponse: QuestionnaireResponse;
    deliveryAddress: Address;
    pendingResolution: CampaignApplicationResolution;
    latestResolution: CampaignApplicationResolution;
    resolutions: CampaignApplicationResolution[];
    discountCode: string;
    isOrdered: boolean;
    orderConfirmedAt: number;
    isDelivered: boolean;
    deliveryConfirmedAt: number;
    dueReviewNotificationsAt: number[];
    deadlineAt: number;
    submittedReviewsCount: number;
}

export interface ReviewerRestApi {
    id: string;
    profile: ReviewerProfile;
    profileImage: File;
    socials: ReviewerSocials;
    isBlacklisted: boolean;
    blacklistedUntil: number;
    totalApplicationsCount: number;
    selectedApplicationsCount: number;
    alternateApplicationsCount: number;
    rejectedApplicationsCount: number;
    clientCounts?: ReviewerClientCounts;
}
